var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.link }}},[_c('i',{staticClass:"pe-7s-user"})])}
var staticRenderFns = []

export { render, staticRenderFns }